import { Yield } from '../../abacus/interfaces/yield.interface'

export const peopleInvolvedYields: Yield[] = [
  {
    label: 'Name',
    property: 'name'
  },
  {
    label: 'Description',
    property: 'description'
  }
]
